import styled from 'styled-components'

export const Heading2 = styled.h2``
